<div class="row">
    <div class="col-12">
        <app-timeline [steps]="steps" [currentStep]="currentStep"></app-timeline>
    </div>
</div>

<div class="row mt-3">
    <div class="col-12">

        <!-- Paso 1: Datos del Socio (Solo Vista) -->
        @if (currentStep === 1) {
        <div class="panel p-4 rounded shadow-sm">
            @if (partyForm) {
            <app-party-form [partyForm]="partyForm" [mode]="FormMode.VIEW"></app-party-form>
            }
            <div class="d-flex justify-content-end mt-3 border-top pt-3">
                <button class="btn btn-secondary me-2" (click)="goBack()">Volver</button>
                <button class="btn btn-primary" (click)="currentStep = 2">
                    Siguiente <i class="fas fa-chevron-right ms-1"></i>
                </button>
            </div>
        </div>
        }

        <!-- Paso 2: Datos del Vehículo -->
        @if (currentStep === 2) {
        <div class="panel p-4 rounded shadow-sm">
            <app-vehicle-form [vehicleForm]="vehicleForm" [mode]="formMode"></app-vehicle-form>
            <div class="d-flex justify-content-end mt-3 border-top pt-3">
                <button class="btn btn-outline-secondary me-2" (click)="currentStep = 1">
                    <i class="fas fa-chevron-left me-1"></i> Anterior
                </button>
                <button class="btn btn-secondary me-2" (click)="goBack()">Cancelar</button>
                <button class="btn btn-primary" (click)="submitVehicle()">
                    <i class="fas fa-save me-1"></i> Guardar y Continuar
                </button>
            </div>
        </div>
        }

        <!-- Paso 3: Documentos -->
        @if (currentStep === 3) {
            @if (documents) {
            <app-document-group [documents]="documents" [mode]="formMode" (formChange)="onDocumentsFormReady($event)">
                <div class="d-flex justify-content-end mt-3 border-top pt-3">
                    <button class="btn btn-outline-secondary me-2" (click)="currentStep = 2">
                        <i class="fas fa-chevron-left me-1"></i> Anterior
                    </button>
                    <button class="btn btn-secondary me-2" (click)="finish()">Omitir / Finalizar</button>
                    <button class="btn btn-primary" (click)="submitDocuments()" [disabled]="isSaving">
                        <i class="fas" [ngClass]="isSaving ? 'fa-spinner fa-spin' : 'fa-save'"></i>
                        {{ isSaving ? 'Guardando...' : 'Guardar y Finalizar' }}
                    </button>
                </div>
            </app-document-group>
            } @else {
            <div class="text-center p-5">
                <i class="fas fa-spinner fa-spin fa-2x"></i>
                <p class="mt-2">Cargando documentos...</p>
            </div>
            }
        }
    </div>
</div>